import { ReportProblem } from "@mui/icons-material";
import { Box, styled } from "@mui/material";

import { palette } from "~frontend/theme";

export const ScriptAlertContainer = styled("div")<{
  $color: string;
  $fontColor: string;
}>(({ theme, $color, $fontColor }) => ({
  backgroundColor: $color,
  color: $fontColor,
  padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  fontSize: "0.75rem",
  fontWeight: 400,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  borderLeft: `1px solid ${$color}`,
  borderRight: `1px solid ${$color}`,
}));

export default function ScriptAlert({
  children,
  severity = "error",
}: {
  children: React.ReactNode;
  severity?: "error" | "warning";
}): React.ReactElement {
  const color = severity === "error" ? palette.red : palette.lightOrange;
  const fontColor = severity === "error" ? palette.white : palette.navy;

  return (
    <ScriptAlertContainer $color={color} $fontColor={fontColor}>
      <ReportProblem fontSize="small" />
      <Box>{children}</Box>
    </ScriptAlertContainer>
  );
}
